import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/core/services/api.service';
import { MessageService } from 'src/app/core/services/message.service';
import { Location } from '@angular/common';
//import { PlantDatDto } from 'src/app/Models/plant-data-dto';
import { PlantDataDto } from 'src/app/dtos/plant-data-dto';
import { Company } from 'src/app/Models/company';
import { AddressControlComponent } from 'src/app/shared/address-control/address-control.component';

@Component({
    selector: 'plants-add',
    templateUrl: './plants-add.component.html',
    styleUrls: ['./plants-add.component.scss']
})
/** plants-add component*/
export class PlantsAddComponent {
    selectedCompany: Company;
    id: any;
    form: FormGroup;
    submitted: boolean;
    plant: PlantDataDto;
    companies: Company[] = [];
    submitButtonText: string = 'GENERAL.LABELS.CREATE';
    isEditing: boolean;
    @ViewChild("addressControl") addressControl: AddressControlComponent;
      constructor(private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private apiService: ApiService,
      private messageService: MessageService, private location: Location) {
        this.id = this.activatedRoute.snapshot.params['id'];
       
      }
  
  ngOnInit(): void {
      this.form = this.formBuilder.group({
        name: ['', Validators.required]
      });
  
      if (this.id) {
        this.isEditing = true;
        this.submitButtonText = 'GENERAL.LABELS.EDIT';
        this.apiService.get('api/plant/dto/' + this.id).subscribe((data: any) => {
          this.plant = data.data;
          this.getCompanies();
          this.form = this.formBuilder.group({
            name: [this.plant.name, Validators.required]
          });
          this.addressControl.setAddressData(this.plant);
          this.addressControl.setLatLong(this.plant.lat, this.plant.long);
        });
  
      }else{
        this.getCompanies();
      }
  
    }

    get controls() { return this.form.controls; }

    getCompanies(){
        this.apiService.get('api/company/findAll').subscribe(response => {
            if(response.data){
                this.companies = response.data;
                if(this.plant){
                    this.companies.forEach(item => {
                        if(item.id == this.plant.company.id){
                            this.selectedCompany = item;
                            return;
                        }
                    });
                    if(!this.selectedCompany){
                        this.selectedCompany = this.companies[0];
                    }
                }
                
            }
        });
    }

    back() {
        this.location.back();
      }
    
    onSubmit() {
        this.submitted = true;
    let addressControlData = this.addressControl.getAddressData();
        if (this.form.invalid || addressControlData.isInvalid) {
          return;
        }
        if(!this.selectedCompany){
            this.messageService.error('Error', 'Debes seleccionar una compañia');
            return;
        }
    
        let customer: PlantDataDto = this.form.value as PlantDataDto;
        let address: PlantDataDto = addressControlData.values as PlantDataDto;
        let model = Object.assign({}, customer, address);
        model.company = this.selectedCompany;
    
        if (this.isEditing) {
          model.id = this.id;
          this.apiService.put('api/plant/updateFromDto', model).subscribe((response:any) => {
              this.messageService.success("USERS.MESSAGES.SUCCESS", "PLANT.MESSAGES.PLANT_UPDATED");
              this.location.back();
          });
        }
        else {
          this.apiService.post('api/plant/saveFromDto', model).subscribe((response:any) => {
              this.messageService.success("USERS.MESSAGES.SUCCESS", "PLANT.MESSAGES.PLANT_SAVED");
              this.location.back();
          });
        }
      }
}
